export function formatFieldError(error) {
  return error.replace(/^.*\^/, "");
}
